import { setLoadingConfigObject } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './HeadLineLoading.config.style';

const headLineLoadingConfig = [
  {
    left: setLoadingConfigObject('square', 1, null, styles.title),
  },
];

export { headLineLoadingConfig }; // eslint-disable-line import/prefer-default-export
